import { ITimeCountDownProps } from "@model/UIComponents.model";
import { useEffect, useState } from "react";
import styles from './UiLibraryComponent.module.css'

const TimeCountDown: React.FC<ITimeCountDownProps> = ({
  message,
  time,
  action,
}) => {
  const [countDown, setCountDown] = useState<number>(time);
  const [actionAllowed, setActionAllowed] = useState<boolean>(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (!actionAllowed) {
      interval = setInterval(() => {
        setCountDown(prev => Math.max(prev - 1, 0));
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [actionAllowed]);

  useEffect(() => {
    if (countDown === 0) {
      setCountDown(time);
      setActionAllowed(true);
    }
  }, [countDown, actionAllowed]);

  const onActionTriggered = () => {
    setActionAllowed(false);     
    setCountDown(time);          
    action(setActionAllowed);    
  };

  return (
    <div className={styles.newRequestContainer} data-testid="time-countdown-container">
      <button
        data-testid="time-countdown-button"
        className={`${styles.newRequest} ${!actionAllowed ? styles.newRequestDisabled : ''}`}
        disabled={!actionAllowed}
        onClick={onActionTriggered}
      >
        {message}
      </button>
      {!actionAllowed && (
        <p data-testid="time-countdown-value" className={styles.countdownTime}>
          {countDown}
        </p>
      )}
    </div>

  );

};

export default TimeCountDown;